import { render, staticRenderFns } from "./hanjiebiao.vue?vue&type=template&id=590aa59c&scoped=true&"
import script from "./hanjiebiao.vue?vue&type=script&lang=js&"
export * from "./hanjiebiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590aa59c",
  null
  
)

export default component.exports